import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'

export default function NotFound() {
const navigate = useNavigate()

return (
<div>
<Header />
<div className="container" style={{ padding: '1rem' }}>
<button className="btn btn-ghost btn-sm" onClick={() => navigate(-1)}>← Back</button>
</div>

{/* Hero — gradient with big 404 */}
<div style={{
background: 'var(--gradient-brand)',
padding: '5rem 1rem',
textAlign: 'center',
position: 'relative',
overflow: 'hidden',
marginTop: 12,
borderTopLeftRadius: 24,
borderTopRightRadius: 24,
}}>
<div style={{
position: 'absolute', inset: 0,
background: 'radial-gradient(circle at 80% 20%, rgba(255,255,255,0.15), transparent 50%)',
pointerEvents: 'none',
}} />
<div style={{ position: 'relative' }}>
<div style={{ fontSize: 72, marginBottom: 8 }}>🔍</div>
<h1 style={{
color: '#fff',
fontFamily: "'Plus Jakarta Sans', sans-serif",
fontWeight: 800,
fontSize: 'clamp(56px, 12vw, 120px)',
margin: 0,
letterSpacing: '-0.04em',
lineHeight: 1,
}}>404</h1>
<h2 style={{
color: '#fff',
fontFamily: "'Plus Jakarta Sans', sans-serif",
fontWeight: 700,
fontSize: 'clamp(22px, 4vw, 32px)',
marginTop: 16,
marginBottom: 12,
letterSpacing: '-0.01em',
}}>Page not found</h2>
<p style={{ color: 'rgba(255,255,255,0.9)', fontSize: 18, maxWidth: 500, margin: '0 auto', lineHeight: 1.6 }}>
We couldn't find the page you were after. It may have moved, or the link might be incorrect.
</p>
</div>
</div>

{/* Actions */}
<div className="container" style={{ maxWidth: 600, padding: '3rem 1rem', textAlign: 'center' }}>
<p style={{ color: 'var(--text-muted)', marginBottom: '2rem', fontSize: 16, lineHeight: 1.6 }}>
Let's get you back on track — try browsing our listings or heading home.
</p>
<div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
<button className="btn btn-gradient btn-lg" onClick={() => navigate('/')}>Back to home</button>
<button className="btn btn-ghost btn-lg" onClick={() => navigate('/')}>Browse listings</button>
</div>
</div>
</div>
)
}
